import { render, staticRenderFns } from "./ShowSegmentModal.vue?vue&type=template&id=545da020&"
import script from "./ShowSegmentModal.vue?vue&type=script&lang=js&"
export * from "./ShowSegmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports